import StoreClosedModal from 'components/StoreClosedModal';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import '../../assets/css/bootstrap.min.css';
import '../../assets/css/icon-new.css';
import '../../assets/css/icon.css';
import '../../assets/css/style.css';
import '../../assets/css/responsive.css';
import '../../assets/css/swiper.min.css';

import '../../index.css'; // add tailwind
import { initLayout } from './actions';
import { selectStoreConfig } from './selectors';

export default function Layout({ children }) {
  const appContainerRef = useRef(null);
  const storeConfig = useSelector(selectStoreConfig);
  const dispatch = useDispatch();

  // Blocks the browser's edge-swipe navigation, but must never cancel a touch
  // that belongs to a zoom gesture or to panning a zoomed-in page.
  const handleTouch = (e) => {
    // A second finger means a pinch is starting: cancelling it would trap the
    // user at the current zoom level.
    if (e.touches.length > 1) return;

    // While zoomed in, the user has to pan from the screen edges to reach
    // content that sits outside the visual viewport.
    if ((window.visualViewport?.scale ?? 1) > 1) return;

    const {
      changedTouches: [{ clientX }],
    } = e;
    // clientX (not pageX) — pageX includes the scroll offset, so it stops
    // matching window.innerWidth as soon as the page is scrolled.
    if (clientX < 10 || clientX > window.innerWidth - 10) e.preventDefault();
  };

  useEffect(() => {
    if (!storeConfig) return;
    dispatch(initLayout(storeConfig));
  }, [storeConfig, dispatch]);

  useEffect(() => {
    const containerRef = appContainerRef.current;
    containerRef?.addEventListener('touchstart', handleTouch);

    return () => {
      containerRef?.removeEventListener('touchstart', handleTouch);
    };
  }, []);

  // const recordPhoneClickHandler = () => {
  //   let obj = {
  //     date: moment().tz(storeConfig.timeZone).format('YYYY-MM-DD HH:mm'),
  //   };
  //   if (
  //     userDetails &&
  //     userDetails.firstName &&
  //     userDetails.lastName &&
  //     userDetails.mobileNumber
  //   ) {
  //     obj.firstName = userDetails.firstName;
  //     obj.lastName = userDetails.lastName;
  //     obj.mobileNumber = getFormattedMobileNumber(userDetails.mobileNumber);
  //   }
  //   obj.storeId = storeConfig.storeId;
  //   obj.restaurantId = storeConfig.restaurantId;
  //   dispatch(recordPhoneClick(obj));
  // };

  return (
    <div ref={appContainerRef}>
      <StoreClosedModal
        storeId={storeConfig.storeId}
        timeZone={storeConfig.timeZone}
      />
    
      {children}
    </div>
  );
}
